import React from 'react';
import { Grid, Typography, Button } from "@mui/material";
import CustomDrawer from "../../components/CustomDrawer";
import { useTranslation } from 'react-i18next';
import { dataUtil, usage_type } from '../../services/wsclients/dataUtil';
import { makeStyles } from '@mui/styles';
import { portalCfg } from '../../config';

const defaultImage = portalCfg.publicPath + "/images/logo.png";

const useStyles = makeStyles((theme) => ({
    content: {
        margin: theme.spacing(3, 0),
    },
    service: {
        padding: theme.spacing(3),
        borderRadius: theme.spacing(3),
        backgroundColor: theme.palette.common.white,
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
    },
    service_icon: {
        textAlign: 'right',
        // backgroundColor: theme.palette.background.primary,
    },
    service_item: {
        cursor: 'pointer'
    },
    product: {
        backgroundColor: theme.palette.background.secondary,
        padding: theme.spacing(3),
        // justifyContent: 'center',
        alignItems: 'center',
        // textAlign: 'center',
    },
    product_img: {
        height: 300,
        [theme.breakpoints.down('md')]: {
            width: '100%',
        },
        padding: theme.spacing(2),
    },
    marginTop3x: {
        marginTop: theme.spacing(3)
    },
}));

export default function OrderExpireView(props) {
    const classes = useStyles();
    const { t } = useTranslation();

    const { open, onClose, detail, currency } = props;
    const product = detail && detail.product ? detail.product : null;
    const img = dataUtil.getImageByUsageTypePortal(product.creatives, usage_type.product_item) ? dataUtil.getImageByUsageTypePortal(product.creatives, usage_type.product_item).url : null

    return (
        <CustomDrawer
            open={open}
            title={t('btn_reorder')}
            onClose={onClose}
        >
            <Grid item xs={12} className={classes.content}>
                {product && <Grid item xs={12}>
                    <Grid item xs={12} container className={classes.product}>
                        <Grid item xs={5} md={4}>
                            <Grid item xs={12} className={classes.image}>
                                <img src={img ? img : defaultImage} alt="Product Image" className={classes.product_img} />
                            </Grid>
                        </Grid>
                        <Grid item xs={7} md={8} className={classes.product_info}>
                            <Grid item xs={12}>
                                <Typography variant='h6'>{product.name ? product.name : null}</Typography>
                            </Grid>
                            {product.price && <Grid item xs={12}>
                                <Typography variant='body2'>{currency}{product.price}</Typography>
                            </Grid>}
                            {product.family && <Grid item xs={12}>
                                <Typography variant='body2'>{product.family.name ? product.family.name : null}</Typography>
                            </Grid>}
                            <Grid item xs={12} className={classes.marginTop3x}>
                                <Button variant='contained' onClick={() => props.onReOrderExpire()}>{t('btn_submit')}</Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>}
            </Grid>
        </CustomDrawer>
    )
}